import { Backdrop, Container, Input, Paper, Select,Divider } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import SearchIcon from '@material-ui/icons/Search';
import { makeStyles } from '@material-ui/styles';
import React, { useEffect, useState } from 'react';
import Alert from 'src/components/Alert';
import Header from 'src/components/Header';
import Page from 'src/components/Page';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import CentralPaper from './CentralPaper';
import CentralPaperDetail from './CentralPaperDetail';
import logger from 'src/utils/logger';


const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  CentralPaperControl: {
    marginTop: theme.spacing(1)
  },
  searchCC: {
    flexGrow: 1,
    height: 42,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center'
  },
  searchIconCC: {
    marginRight: theme.spacing(0),
    color: theme.palette.icon
  },
  searchInputCC: {
    flexGrow: 1
  },
  searchButtonCC: {
    backgroundColor: theme.palette.common.white,
    marginLeft: theme.spacing(2)
  },
  backdropCC: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  inputAtananCC: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  pageStyleAtananCC: {
    display: 'flex',
    padding: '2px 4px',
  },
}));

const CentralPaperControlServiceShop = props => {
  const classes = useStyles();
  const [PaperData, setPaperData] = useState([]);
  const SessionUser = getUser();
  const [Loading, setLoading] = useState(false);
  const [FilterPaper, setFilterPaper] = useState('');
  const [stateSearchType, setstateSearchType] = useState("FIS_NO");
  const [displayDetail, setDisplayDetail] = useState(false);
  const [detailData, setDetailData] = useState({});
  const [uyariTip, setUyariTip] = useState();
  const [uyariAciklama, setUyariAciklama] = useState('');
  const [uyari, setUyari] = useState(false);

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  const SearchPaperDetail = (searchType, searchText) => {
    setDisplayDetail(false);
    setDetailData({});
    setLoading(true);
    axios.get('/GetArtemisPaperDetailServis/' + SessionUser.ServiceShopId + '/' + SessionUser.UserId + '/' + searchType + '/' + searchText).then((response) => {
      const PaperCC = response.data;
      setPaperData(PaperCC);
      setLoading(false);
    }).catch(error => {
      setUyariTip("error");
      setUyariAciklama("Yetkiniz bulunmamaktadır!...");
      setUyari(true);
      setLoading(false);
            logger.error("Hata detayı:", error.message);
    });
  };
  const handleChangeSearchType = (value) => {
    setstateSearchType(value);
  };

  const handleOpenDetail = (Data) => {
    setDetailData(Data);
    setDisplayDetail(true);
  }

  const handleCloseDetail = () => {
    setDetailData({});
    setDisplayDetail(false);
  }

  const ChangeFilter = (value) => {
    if (stateSearchType === "TELEFON") {
      value = value?.replaceAll(" ", "")?.replaceAll("+", "")?.replaceAll("(", "");

      if (value.substring(0, 1) === "0") {
        value = value.substring(1, value.length);
      }
    }
 
    setFilterPaper(value);
  };


  useEffect(() => {
    const { searchType, searchText } = props.match.params;

    if (searchType && searchText && ["FIS_NO", "ADSOYAD", "TELEFON"].indexOf(searchType) !== -1 && searchText.length > 0) {
      handleChangeSearchType(searchType);
      ChangeFilter(searchText);
      SearchPaperDetail(searchType, searchText);
    }

    // eslint-disable-next-line
  }, [props.match.params]);


  return (
    <Page className={classes.root} title='Fiş Detayları'>
      <Container maxWidth="lg">
        <Header />
        {
          Loading ?
            <Backdrop className={classes.backdropCC} open={Loading}>
              <CircularProgress color="inherit" />
            </Backdrop>
            : <div></div>
        }
        <Paper component="form" elevation={3}>
          <Select
            native
            value={stateSearchType}
            disableUnderline
            className={classes.searchInputCC}
            onChange={e => handleChangeSearchType(e.target.value)}
            label="AramaTip">
            <option value="FIS_NO">Fiş Numarası ile Arama</option>
            <option value="ADSOYAD">Müşteri Adı Soyadı ile Arama</option>
            <option value="TELEFON">Telefon Numarası ile Arama</option>
          </Select>
        </Paper>
        <br />
        <Paper
          elevation={3}>
          <Input
            className={classes.searchInputCC}
            disableUnderline
            value={FilterPaper}
            onChange={e => ChangeFilter(e.target.value)}
            placeholder="Arama yapınız!..."
          />
           <Divider orientation="vertical" flexItem />
          <SearchIcon onClick={() => SearchPaperDetail(stateSearchType, FilterPaper)} className={classes.searchIconCC} />
        </Paper>
        {
          uyari ?
            <Alert onClose={uyariKapat} open={uyari} message={uyariAciklama || ''} variant={uyariTip} />
            : <div></div>
        }
        {displayDetail ?
          <CentralPaperDetail className={classes.CentralPaperControl}
            item={detailData}
            loading={Loading}
            handleCloseDetail={handleCloseDetail}
          />
          :
          PaperData && PaperData.length > 0 &&
          <CentralPaper
            className={classes.CentralPaperControl}
            items={PaperData}
            loading={Loading}
            handleOpenDetail={handleOpenDetail}
          />
        }
      </Container>
    </Page>
  );
}


export default CentralPaperControlServiceShop;
